var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuySell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 128,
    viewBox: "0 0 123 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_6566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2607 26.2578L15.1097 29.7761L7.33105 114.991L18.4196 113.741L23.5553 115.817L27.7073 118.768L28.6827 120.01L30.5503 120.577L31.8092 122.453L20.8291 28.4338L17.2607 26.2578Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2607 26.2582C23.9222 25.7997 30.2418 25.3745 36.7449 24.9243C36.2113 18.2045 38.2373 12.5268 43.298 8.12472C46.7746 5.0983 50.9015 3.65596 55.4787 3.49755C63.7576 3.20575 74.9712 8.84173 76.7804 22.9984C82.0745 22.9984 87.4103 22.9984 92.7545 22.9984C92.7629 23.1484 92.7712 23.2985 92.7795 23.4486C87.6438 24.2156 82.4997 24.9826 77.1472 25.783C77.5224 28.2759 77.8475 30.6937 78.2894 33.0948C78.3561 33.4366 78.973 33.7117 79.3816 33.9452C81.8911 35.3458 83.1 38.0554 82.3246 40.5983C81.6576 42.791 79.8485 44.225 77.489 44.4168C75.1713 44.6085 72.7952 43.1745 71.803 40.9818C70.8442 38.8642 71.1444 36.438 72.8535 34.9373C73.8373 34.0702 73.9707 33.2865 73.7122 32.1026C73.3287 30.2935 73.1453 28.4426 72.8869 26.6668C62.507 27.4421 52.2272 28.2175 41.7639 29.0012C42.1724 31.6274 42.5309 34.2036 43.0062 36.7632C43.0812 37.1717 43.6398 37.5802 44.065 37.822C45.9742 38.8975 47.1248 40.4732 47.2832 42.6576C47.4999 45.6257 45.3489 48.0268 42.3142 48.3186C39.3461 48.6021 36.4364 46.3093 36.1196 43.4246C35.9028 41.4487 36.4114 39.7562 37.9705 38.4139C38.2956 38.1388 38.6041 37.6553 38.6208 37.2551C38.6458 36.5547 38.4374 35.8544 38.329 35.1457C38.0288 33.2115 37.7204 31.2773 37.3952 29.2263C32.3262 29.5681 27.3822 29.8933 22.2381 30.2434C26.5985 59.107 30.9422 87.8038 35.3192 116.767C58.1049 109.414 80.5321 101.327 103.601 96.8497C80.7989 107.471 56.2457 114.325 31.8092 122.453C26.957 90.3717 22.1214 58.3983 17.2607 26.2582ZM41.2387 24.5491C51.6019 23.9238 61.89 23.2985 72.1782 22.6816C71.8947 15.1697 64.7747 7.19929 55.0201 7.86627C46.0743 8.47489 39.8463 16.1201 41.2387 24.5491Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75746 112.549C18.8534 110.707 28.708 115.15 31.8095 122.446C31.526 121.787 28.8748 120.77 28.2078 120.386C26.8905 119.619 25.5649 118.869 24.1892 118.219C17.8613 115.234 10.4995 115.842 4.81348 120.003C4.88017 118.644 4.88851 117.71 4.97188 116.776C5.47212 111.44 5.98903 106.096 6.4976 100.76C7.23128 93.0817 7.96496 85.3948 8.6903 77.7162C9.28224 71.4466 9.85751 65.1853 10.4411 58.9157C11.0164 52.7545 11.6584 46.5932 12.6755 40.482C13.1757 37.4723 13.5176 34.4292 14.3429 31.4862C14.493 30.9692 16.4856 25.6668 17.7279 26.2504C18.0447 26.4004 17.7362 27.651 17.7529 27.9762C17.8446 29.5352 17.7112 31.1193 17.6028 32.67C17.3027 36.7553 16.8024 40.8239 16.2855 44.8924C16.0437 46.7933 15.7353 48.6942 15.5769 50.6035C15.1267 56.006 14.5597 61.3919 14.0428 66.7861C13.3175 74.4146 12.5838 82.0432 11.8668 89.6718C11.2748 95.9414 10.6912 102.203 10.1076 108.472C9.99091 109.815 9.88252 111.157 9.75746 112.549Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.81 94.4296C111.347 94.4296 118.267 87.5092 118.267 78.9724C118.267 70.4356 111.347 63.5151 102.81 63.5151C94.273 63.5151 87.3525 70.4356 87.3525 78.9724C87.3525 87.5092 94.273 94.4296 102.81 94.4296Z",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.364 77.1609V80.7709H95.2568V77.1609H110.364ZM104.711 86.5236H100.918V71.4165H104.711V86.5236Z",
    fill: "white",
    fillOpacity: 0.56
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_6566",
    x: 0.813477,
    y: 0.486816,
    width: 121.454,
    height: 126.967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_6566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_6566",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuySell);
export default __webpack_public_path__ + "static/media/Buy&Sell.e17540fbcb503954150a3bd5adb374d8.svg";
export { ForwardRef as ReactComponent };